import { render, staticRenderFns } from "./OcrStep.vue?vue&type=template&id=d05c7450"
import script from "./OcrStep.vue?vue&type=script&lang=js"
export * from "./OcrStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports